import React from "react";

const ITEMS = [
  "LOGIKA EKSAKTA",
  "OLIMPIADE NASIONAL",
  "CORPORATE TRAINING",
  "KURIKULUM & SILABUS",
  "SERTIFIKASI SDM",
  "PROBLEM SOLVING",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="marquee" className="border-y border-white/10 bg-navy-soft py-5 overflow-hidden mask-fade-x">
      <div className="flex w-max animate-marquee gap-0">
        {row.map((t, i) => (
          <div key={i} className="flex items-center gap-8 px-8 shrink-0">
            <span className="font-heading text-sm md:text-base tracking-[0.25em] uppercase text-slate-400">{t}</span>
            <span className="text-gold text-lg">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
};
